"use client"

export function AnimatedBackground() {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      <div className="absolute inset-0 bg-linear-to-br from-green-50 via-emerald-50 to-green-100 opacity-60"></div>
      <div className="absolute inset-0">
        {/* Simplified background - single subtle element */}
        <div className="absolute bottom-0 left-0 w-full h-32 bg-linear-to-t from-green-100/30 to-transparent"></div>
        <div className="absolute top-1/4 left-1/4 w-2 h-16 bg-green-200/20 rounded-full animate-pulse-soft"></div>
      </div>
    </div>
  )
}
